import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import '../../app-configuration/app-configuration.js';
import { KatapultPageElement, html } from '../../mixins/katapult-page-element.js';
import { MutableData } from '@polymer/polymer/lib/mixins/mutable-data';
import '@polymer/paper-input/paper-textarea';
import '@polymer/iron-icons/av-icons';
import '@polymer/neon-animation/neon-animation.js';
import '@polymer/paper-menu-button/paper-menu-button.js';
import '@polymer/iron-collapse/iron-collapse.js';
import '../katapult-firebase-worker/katapult-firebase-worker';
import '../katapult-auth/katapult-auth';
import '../katapult-toolbar/katapult-toolbar';
import '../katapult-map-icons/katapult-map-icons';
import '../paper-table/paper-table';
import '../paper-header/paper-header';
import '../auth-z-vision/auth-z-vision.js';
import '../style-modules/paper-table-style';
import '../style-modules/paper-dialog-style';
import '../style-modules/paper-tooltip-style';
import '../style-modules/flex.js';
import '../material-icon/material-icon';
import './katapult-home-widgets/client-coding-dashboard-widget.js';
import './katapult-home-widgets/katapult-company-widget.js';
import './katapult-home-widgets/company-resources.js';
import './katapult-home-widgets/katapult-widget.js';
import './katapult-home-widgets/katapult-task-widget.js';
import './katapult-home-widgets/katapult-feedback-widget.js';
import './katapult-home-widgets/katapult-proficiency-widget.js';
import './katapult-home-widgets/katapult-timesheet';
import './katapult-home-widgets/kpi-report-downloader.js';
import './katapult-home-widgets/training-links-widget.js';
import './katapult-home-widgets/test-widget.js';
import './katapult-home-widgets/stopwatch-widget.js';
import './katapult-home-widgets/kpi-widget.js';
import './katapult-home-widgets/katapult-reference-widget.js';
import './katapult-home-widgets/katapult-teamhealth-widget.js';
import './katapult-home-widgets/test-paper-header';
import './katapult-home-widgets/katapult-project-billable-widget';
import './katapult-home-widgets/katapult-api-widget.js';
import './katapult-home-widgets/estimator-widget.js';
import '../progress-bar/progress-bar.js';
import './widget-library-card';
import './katapult-home-widgets/katapult-meeting-widget.js';
import '../katapult-elements/katapult-button.js';
import { addFlagListener, removeFlagListener } from '../../modules/FeatureFlags.js';
import { getTeamsUserIsALeaderOf } from '../../modules/katapult-company/CompanyTeams.js';
import { ListenToUserRole } from '../../modules/Roles.js';

class KatapultHome extends MutableData(KatapultPageElement) {
  static get template() {
    return html`
      <style include="paper-tooltip-style flex">
        :host {
          display: block;
          height: 100%;
          width: 100%;
          background: var(--paper-grey-50);
        }
        katapult-button[edit-mode] {
          background-color: #fff;
          color: '#FF8300';
        }
        #widgetLibControl {
          padding: 8px;
          color: var(--primary-text-color-faded);
        }
        #widgetLibControl[edit-mode] {
          color: #ff8300;
        }
        #widgetLibrary {
          background-color: var(--paper-grey-200);
          box-shadow: 0px -6px 8px var(--paper-grey-400) inset;
        }
        .libIcon {
          color: #424242;
          padding: 0px 25px 0px 25px;
          font-size: 12pt;
          display: flex;
          border: 0;
        }
        #widgetContainer {
          display: flex;
          position: relative;
          flex-wrap: wrap;
          justify-content: flex-start;
          overflow-y: auto;
          padding: 0.5em;
          gap: 1em;
          height: 100%;
        }
        .widgetCase {
          display: flex;
          padding: 0.5em;
          flex: 1 1 32%;
          flex-flow: column wrap;
          max-width: 850px;
        }
        .widgetCase > * {
          margin-bottom: 16px;
        }
        paper-cell[icon] {
          max-width: 24px;
          padding: 0;
        }
        .dragging {
          opacity: 0.5;
          cursor: grabbing !important;
        }
        #editJobNameInputCheck {
          color: #e0e0e0;
          transition:
            transform 0.4s,
            color 0.1s;
          transform: scale(0);
        }
        .done {
          border-radius: 999px;
          background-color: var(--paper-green-400);
          width: 24px;
          height: 24px;
          z-index: 3;
          color: #fff;
          cursor: pointer;
        }
        #emptyMessage {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          font-size: 36px;
          display: flex;
          justify-content: center;
          margin-top: 20%;
          color: var(--primary-text-color-faded);
        }
      </style>
      <katapult-auth
        user="{{user}}"
        user-group="{{userGroup}}"
        signed-in="{{signedIn}}"
        title="[[config.firebaseData.name]] Home"
        no-signup="[[!config.firebaseData.offerLicenses]]"
      >
        <div slot="title-content">
          <p
            style="margin: 0; text-transform: uppercase; font-size: 18pt; text-color: var(--primary-text-color-faded); font-weight: lighter"
          >
            [[config.firebaseData.name]] Home
          </p>
        </div>
        <div style="display: flex; flex-direction: column;" slot="auth-content">
          <auth-z-vision user="[[user]]"></auth-z-vision>
          <!-- toolbar -->
          <katapult-toolbar user-group="[[userGroup]]">
            <!-- left -->
            <div id="title" slot="left" style="display: flex; justify-content: center; align-items: center;">
              <div style="display: inline-block">[[config.firebaseData.name]] Home</div>
            </div>
            <template is="dom-if" if="[[modelOptions.length]]">
              <div slot="center" id="modelEditorDropdown">
                <katapult-drop-down
                  items="[[modelOptions]]"
                  value="{{editingCompany}}"
                  label="Models"
                  label-path="label"
                  value-path="value"
                ></katapult-drop-down>
                <template is="dom-if" if="{{systemAdmin}}">
                  <iron-icon icon="icons:add" on-click="openModelSetDialog"></iron-icon>
                </template>
              </div>
            </template>
            <!-- right -->
            <div slot="right">
              <katapult-button
                iconOnly
                noBorder
                id="widgetLibControl"
                edit-mode$="[[editMode]]"
                textColor=""
                icon="tune"
                on-click="toggleEditMode"
              ></katapult-button>
              <paper-tooltip for="widgetLibControl" offset="15">Edit Widgets</paper-tooltip>
            </div>
          </katapult-toolbar>

          <!-- backend data -->
          <katapult-firebase-worker
            child-events
            id="cases"
            path="photoheight/company_space/[[userGroup]]/user_data/[[user.uid]]/home/layout/cases"
            data="{{cases}}"
            loaded="{{casesLoaded}}"
            disabled="[[!signedIn]]"
          >
          </katapult-firebase-worker>
          <katapult-firebase-worker
            id="widgetCatalog"
            path="photoheight/home/widget_catalog/widget_library"
            data="{{catalogedWidgets}}"
            disabled="[[!signedIn]]"
          >
          </katapult-firebase-worker>

          <!-- widget library -->
          <div>
            <iron-collapse id="widgetLibrary" opened="[[editMode]]">
              <div flex column style="padding: 24px; gap: 16px;">
                <div>Click on a widget to add it to your home page</div>
                <div flex style="gap: 8px;">
                  <template is="dom-repeat" items="{{availableWidgets}}">
                    <widget-library-card
                      widget-label="{{item.label}}"
                      widget-name="{{item.name}}"
                      icon="{{item.icon}}"
                      on-add-widget-clicked="addWidgetHandler"
                    ></widget-library-card>
                  </template>
                </div>
              </div>
            </iron-collapse>
          </div>

          <!-- widget container -->
          <div id="widgetContainer" on-remove-widget-clicked="removeWidget">
            <template is="dom-repeat" items="[[cases]]" index-as="caseIndex" restamp="true" on-dom-change="updateWidgetElements">
              <div class="widgetCase" id="widgetCase[[caseIndex]]" on-dragenter="_handleWidgetDragEnter" on-drop="dropHandler"></div>
            </template>

            <!-- /home is empty message -->
            <template is="dom-if" if="[[!widgetCount]]" restamp="true">
              <div id="emptyMessage">
                <span style="text-align: center;">
                  It's feeling lonely.<br />Click
                  <material-icon style="display: inline; margin: 0px 4px;" size="large" icon="tune"></material-icon>
                  in the toolbar to add your first widget!
                </span>
              </div>
            </template>
          </div>
        </div>
      </katapult-auth>
    `;
  }
  static get properties() {
    return {
      cases: {
        notify: true
      },
      editMode: {
        type: Boolean,
        value: false
      },
      availableWidgets: {
        type: Array,
        computed: 'filterCatalogedWidgets(catalogedWidgets, userGroup)'
      },
      widgetCount: {
        type: Number,
        computed: 'computeWidgetCount(cases.*)'
      },
      enabledFeatures: {
        type: Object,
        value: () => ({})
      }
    };
  }

  static get observers() {
    return [
      '_maybeAddTimesheetWidget(casesLoaded, _timesheetsEnabled, isTimesheetManager)',
      'updateWidgetElements(cases.*, _timesheetsEnabled)',
      'updateUserHomeRef(user.uid, userGroup)',
      '_updateTimesheetsEnabledRef(signedIn, userGroup)',
      '_updateRolesListeners(user.uid, userGroup)'
    ];
  }

  constructor() {
    super();

    /** @type { boolean } */
    this.signedIn = false;

    /** @type { ?string } */
    this.userGroup = null;

    /** @type { boolean } */
    this._timesheetsEnabled = false;

    /** @type { ?function } */
    this._disconnectTimesheetsEnabledFirebaseListener = null;

    /** @type { function[] } */
    this._rolesListeners = [];
  }

  connectedCallback() {
    super.connectedCallback();

    // Set up the feature flag listeners
    this.migratingTimesheetWidgetFlagListener = addFlagListener('migrating_timesheet_widget', (enabled) => {
      this.set('enabledFeatures.migrating_timesheet_widget', enabled);
      this.disabledTimesheetWidgetSetDisabledModeIfApplicable();
    });
    this._updateTimesheetsEnabledRef();
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    // Remove the feature flag listeners
    removeFlagListener('migrating_timesheet_widget', this.migratingTimesheetWidgetFlagListener);
    this._disconnectTimesheetsEnabledFirebaseListener?.();
  }

  disabledTimesheetWidgetSetDisabledModeIfApplicable() {
    const timesheetWidget = this.shadowRoot.querySelector('katapult-timesheet');
    if (!timesheetWidget) return;
    timesheetWidget.disabledMode = this.enabledFeatures.migrating_timesheet_widget === true;
  }

  async _maybeAddTimesheetWidget() {
    const { casesLoaded, cases, _timesheetsEnabled } = this;
    if (!casesLoaded || !_timesheetsEnabled) return;

    const allWidgets = cases?.flatMap((x) => x.widgets ?? []) || [];
    const timesheetWidgetAlreadyAdded = allWidgets.some((x) => x.name == 'katapult-timesheet');
    if (!timesheetWidgetAlreadyAdded) this.addWidget('katapult-timesheet');

    const isTeamLead =
      this.isTimesheetManager || (await getTeamsUserIsALeaderOf(firebase.firestore(), this.userGroup, this.user.uid)).length > 0;
    const teamHealthWidgetAlreadyAdded = allWidgets.some((x) => x.name == 'katapult-teamhealth-widget');
    if (isTeamLead && !teamHealthWidgetAlreadyAdded) this.addWidget('katapult-teamhealth-widget');
  }

  _updateTimesheetsEnabledRef() {
    this._disconnectTimesheetsEnabledFirebaseListener?.();

    const { signedIn, userGroup } = this;
    if (!signedIn || userGroup == null) return;

    const timesheetsEnabledRef = globalThis.FirebaseWorker.ref(`photoheight/company_space/${userGroup}/options/list/timesheets`);

    const callback = (snapshot) => (this._timesheetsEnabled = snapshot.val() === true);
    timesheetsEnabledRef.on('value', callback);

    this._disconnectTimesheetsEnabledFirebaseListener = () => {
      timesheetsEnabledRef.off('value', callback);
      this._timesheetsEnabled = false;
      this._disconnectTimesheetsEnabledFirebaseListener = null;
    };
  }

  ready() {
    super.ready();
    this.appConfiguration = new AppConfiguration(this);
  }

  _handleWidgetDragEnter(e) {
    // Ignore dragenter events we don't care about
    if (!this.editMode || !this.dragging) return;

    // We're using custom logic; prevent default behaviors
    e.preventDefault();
    // Also stop it from bubbling up so we can handle it here
    e.stopPropagation();

    const targetElement = e.currentTarget;
    let insertPosition = 'beforebegin';
    // If this event handler was triggered by the widgetCase class
    if (targetElement.classList.contains('widgetCase')) insertPosition = 'beforeend';
    targetElement.insertAdjacentElement(insertPosition, this.dragging);
  }

  async addWidgetHandler(e) {
    const newWidgetName = e.detail.widget;
    await this.addWidget(newWidgetName);
  }

  /**
   * @param {string} newWidgetName
   * @param {number} [caseIndex]
   */
  async addWidget(newWidgetName, caseIndex) {
    // If cases is null, we need to do some additional set up
    if (!this.cases) {
      const baseStructure = [{ exists: true }, { exists: true }, { exists: true }];
      caseIndex ??= 0;
      baseStructure[caseIndex].widgets = [{ name: newWidgetName }];
      await this.userHomeRef?.child('layout/cases').set(baseStructure);
      // We need to update the worker listeners because the data didn't exist before
      this.$.cases._updateListeners();
    } else {
      // Find the case with the most room
      caseIndex ??= this.findSpaciousCase();
      const newWidgetIndex = this.cases?.[caseIndex]?.widgets?.length ?? 0;
      // Run the update
      await this.userHomeRef?.child(`layout/cases/${caseIndex}/widgets/${newWidgetIndex}`).set({ name: newWidgetName });
    }
  }

  removeWidget(e) {
    // Case index is last char of parent div ID
    const caseIndex = e.detail.parentElementId.at(-1);
    const widgets = this.cases[caseIndex].widgets;
    const widgetName = e.detail.widget.tagName.toLowerCase();

    // The timesheet widgets are now shown/hidden when timesheets are enabled/disabled.  Don't allow them to be manually removed.
    if (widgetName == 'katapult-timesheet' || widgetName == 'katapult-teamhealth-widget') return;

    const widgetIndex = widgets.findIndex((x) => x.name == widgetName);

    // Imutable splice: remove the widget and keep the others, but update indices
    const updatedWidgets = [...widgets.slice(0, widgetIndex), ...widgets.slice(widgetIndex + 1)];

    // Send the updated array to firebase
    this.userHomeRef?.child(`layout/cases/${caseIndex}/widgets`).set(updatedWidgets);
  }

  async repositionAllWidgets() {
    const widgetCaseElements = this.shadowRoot.querySelectorAll(`.widgetCase`);
    let update = {};
    for (const widgetCaseElement of widgetCaseElements) {
      // Case index is last char of parent div ID
      const caseIndex = widgetCaseElement.id.at(-1);
      // Get an updated version of the widget array
      const updatedWidgets = [...widgetCaseElement.children].map((x) => ({ name: x.tagName.toLowerCase() }));

      // Send the updated array to firebase
      update[`${caseIndex}/widgets`] = updatedWidgets;
    }
    await this.userHomeRef?.child(`layout/cases`).update(update);
  }

  /** When the cases prop changes (usually from the DB), we need to re-seat the widgets */
  updateWidgetElements() {
    const { cases, _timesheetsEnabled } = this;
    const casesEntries = Object.entries(cases ?? {});
    for (const [caseIndex, widgetCase] of casesEntries) {
      const caseElement = this.$$(`#widgetCase${caseIndex}`);
      const newElementList = [];
      const widgetsEntries = Object.entries(widgetCase?.widgets ?? {});
      const filteredWidgetsEntries = widgetsEntries.filter(([, widget]) => {
        // If timesheets are disabled, don't show the timesheet widget.
        if ((widget.name == 'katapult-timesheet' || widget.name == 'katapult-teamhealth-widget') && !_timesheetsEnabled) return false;
        return true;
      });
      for (const [widgetIndex, widget] of filteredWidgetsEntries) {
        const elementAtIndex = caseElement?.children?.[widgetIndex];
        if (!elementAtIndex || elementAtIndex.tagName.toLowerCase() != widget.name) {
          newElementList[widgetIndex] = this.createWidget(widget.name);
        } else newElementList[widgetIndex] = elementAtIndex;
      }
      caseElement?.replaceChildren(...newElementList);
    }

    this.disabledTimesheetWidgetSetDisabledModeIfApplicable();
  }

  computeWidgetCount() {
    if (!this.cases) return 0;
    return this.cases.reduce((acc, x) => acc + (x?.widgets?.length ?? 0), 0);
  }

  // limit widget library to the widgets the user has access to
  filterCatalogedWidgets(catalog, userGroup) {
    if (!catalog) return;
    // If catalog does exist, try to filter it
    const availableWidgets = catalog.filter((x) => {
      // The timesheet widgets and feedback widget show / hide programmatically, so don't show them in the library
      const widgetNamesToSkip = ['katapult-timesheet', 'katapult-teamhealth-widget', 'katapult-feedback-widget'];
      if (widgetNamesToSkip.includes(x.name)) return false;
      // No access rules are defined, or...
      return (
        x.access == undefined ||
        // all users in the user group, or...
        x.access?.[userGroup]?.users == 'all' ||
        // you, in your user group
        x.access?.[userGroup]?.users[this.user.uid]
      );
    });

    // Always add the katapult-feedback-widget to the list of available widgets and give it the proper label
    availableWidgets.unshift({
      name: 'katapult-feedback-widget',
      label: 'Feedback Widget',
      icon: 'group_add'
    });

    return availableWidgets;
  }

  /*
   * takes the widget name (a string indicating the element name of the widget),
   * creates the widget (along with event listeners, properties, and
   * attributes), and returns the html element
   */
  createWidget(widgetName) {
    // create widget
    const newWidget = document.createElement(widgetName);

    newWidget.addEventListener(
      'widget-ready',
      () => {
        // Add handlers for drag-handle events
        const newWidgetDragHandles = newWidget.shadowRoot.querySelectorAll('.headerDragHandle');
        newWidgetDragHandles.forEach((x) => {
          x.addEventListener('mousedown', () => (newWidget.draggable = true));
          x.addEventListener('mouseup', () => (newWidget.draggable = false));
        });

        // add event listeners
        newWidget.addEventListener('dragstart', (e) => {
          // Do nothing if the widget itself is not draggable (per the drag handle)
          if (!newWidget.draggable) return;
          newWidget.classList.add('dragging');
          this.dragging = newWidget;
        });

        newWidget.addEventListener('dragend', (e) => {
          newWidget.classList.remove('dragging');
          this.repositionAllWidgets();
          this.dragging = null;
        });

        newWidget.addEventListener('dragenter', (e) => this._handleWidgetDragEnter(e));
      },
      { once: true }
    );

    // add attributes and properties
    newWidget.userGroup = this.userGroup;
    newWidget.user = this.user;
    newWidget.catalogData = this.catalogedWidgets?.find((x) => x.name == widgetName);
    newWidget.classList.add('widget');
    newWidget.setAttribute('edit-mode', this.editMode);
    if (widgetName == 'katapult-timesheet' || widgetName == 'katapult-teamhealth-widget')
      newWidget.setAttribute('hide-remove-icon', 'true');

    return newWidget;
  }

  toggleEditMode() {
    this.editMode = !this.editMode;
    const activeWidgets = this.shadowRoot.querySelectorAll('.widget');
    for (const widget of activeWidgets) {
      widget.setAttribute('edit-mode', this.editMode);
      widget.setAttribute('draggable', this.editMode);
    }
  }

  // calculates which case has the most space for adding widgets to /home
  findSpaciousCase() {
    if (!this.cases) return 0;

    let spaceyCaseArea = 0;
    let finalCaseIndex = 0;

    // loop through cases and calculate total area, area taken up by widgets, and resulting empty space
    for (let caseIndex = 0; caseIndex < this.cases.length; caseIndex++) {
      let potentialCase = this.shadowRoot.getElementById(`widgetCase${caseIndex}`);
      // If no case exists, skip it
      if (!potentialCase) continue;
      let potentialCaseArea = potentialCase.offsetHeight * potentialCase.offsetWidth;

      var subarea = 0;
      // loop through children to calculate the occupied subarea
      for (let child = 0; child < potentialCase.children.length; child++) {
        subarea += potentialCase.children[child].offsetHeight * potentialCase.children[child].offsetWidth;
      }

      potentialCaseArea -= subarea;
      // if leftover space is greater than that on record, save it and the case
      if (potentialCaseArea > spaceyCaseArea) {
        spaceyCaseArea = potentialCaseArea;
        finalCaseIndex = caseIndex;
      }
    }
    return finalCaseIndex;
  }

  updateUserHomeRef() {
    if (this.userGroup == null || this.user.uid == null) return;
    this.userHomeRef = FirebaseWorker.database().ref(`photoheight/company_space/${this.userGroup}/user_data/${this.user.uid}/home`);
  }

  _updateRolesListeners() {
    this._rolesListeners.forEach((unsubscribe) => unsubscribe());

    if (!this.userGroup || !this.user.uid) return;

    this._rolesListeners = [
      ListenToUserRole(
        this.user.uid,
        'timesheet_manager',
        this.userGroup,
        (isTimesheetManager) => (this.isTimesheetManager = isTimesheetManager)
      )
    ];
  }
}

window.customElements.define('katapult-home', KatapultHome);
